import React from "react";
import { Row } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars-2";
import { suggestedItem } from "../../../models/cart.model";
import styleClasses from "../../Header/Header.module.scss";
import SuggestedItemCard from "./SuggestedItemCard";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface ISuggestedItemsList {
  list: any[];
  title: string;
  setMyRewards: (arr: any[]) => void
  isRewardList: boolean;
  closeModal:() => void;
  addToOrder: any;
}

const SuggestedItemsList: React.FC<ISuggestedItemsList> = ({
  list,
  title,
  setMyRewards,
  isRewardList,
  closeModal,
  addToOrder,
}) => {
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const getBtnText = (reward) => {
    if (isRewardList) {
      return reward.is_active_in_cart ? 'Redeemed' : 'Redeem'
    }
    return isRewardList ? 'Redeem' : 'Add';
  }

  if (!list.length) return null;

  return <div className={`${styleClasses.other_products_wrap} ${isDesignV2 ? styleClasses.redeemm_reward_wrap_mobile_designv2  : ''}`}>
      <h4 className={`font-Cls lh-normal ls-normal mb-3 ${isDesignV2 ? 'f-sm-s21 f-w4 clr-dark-grey' : 'f-s22 f-sm-s16'}`}>
        {title} 
      </h4>
      <Row className={`flex-nowrap ${styleClasses.suggestion_row} ${isDesignV2 ? 'pt-0' : 'pt-1'}`}>
        <Scrollbars
          className={styleClasses.other_products_Scrollbar + " mb-mb-4"}
          renderThumbHorizontal={(props) => (
            <div {...props} className={styleClasses.Scrollbar_thumb} />
          )}
          renderView={(props) => (
            <div {...props} className={styleClasses.Scrollbar_view} />
          )}
        >
          {list.map((item: suggestedItem, index: number) => (
            <SuggestedItemCard
              rewardList={list}
              setMyRewards={setMyRewards}
              addToOrder={addToOrder}
              closeModal={closeModal}
              suggestedItem={item}
              isRewardList={isRewardList}
            />
          ))}
        </Scrollbars>
      </Row>
      </div>
};

export default SuggestedItemsList;
